import gb from 'date-fns/locale/en-GB'
import type { ReactChild } from 'react'
import type React from 'react'
import DatePicker, { registerLocale } from 'react-datepicker'
import styled from 'styled-components'
registerLocale('gb', gb)

interface Props {
  label?: ReactChild
  date: Date | null
  setDate: (date: Date | null) => void
  endDate?: Date
  disabled?: boolean
}

const Container = styled.div`
  input {
    padding: 10px;
    border-radius: 5px;
    outline: none;
  }
`

const DateInput: React.FC<Props> = ({ label, date, setDate, endDate, disabled }) => {
  return (
    <Container className="date-selector">
      {label && <div>{label}</div>}
      <DatePicker
        endDate={endDate}
        dateFormat="dd/MM/yyyy"
        locale="gb"
        selected={date}
        onChange={(date: Date) => setDate(date)}
        disabled={disabled}
      />
    </Container>
  )
}

export default DateInput
